import sendData from '../../../../utils/sendData'

export const click = (chipsType: number | 'pending', pendingAmount: number) => {
  sendData('account.finance.add_funds.chips.click', {
    chipsType,
    pendingAmount,
  })
}
